export enum ProjectStatusTypes{
    Active = 1,
    Completed = 2,
    Cancelled = 3,
    Delayed = 4,
    OnHold = 5,
    Deleted = 6,
}